
  import Vue from "vue";
  import PwaCountdownMessage from "@/components/common/PwaCountdownMessage.vue";
  import PwaCompetitionRoundMatchResult from "@/components/competitions/PwaCompetitionRounds/PwaCompetitionRoundMatchResult.vue";
  import {COMPETITION_STATUS_ID} from "@/utils/competition";

  export default Vue.extend({
    name: "pwa-competition-rounds",
    components: {
      PwaCountdownMessage,
      PwaCompetitionRoundMatchResult,
      PwaAccordion: () => import("@/components/common/PwaAccordion.vue"),
      PwaIcon: () => import("@/components/common/PwaIcon.vue"),
    },
    props: {
      competition: {
        type: Object,
        required: true
      },
      isUserInCompetition: {
        type: Boolean,
        required: false,
      },
      roundResults: {
        type: Array,
        required: false,
        default: null,
      },
      dateRounds: {
        type: Array,
        required: false,
        default: null,
      },
      currentRound: {
        type: Number,
        required: false,
        default: 1,
      },
      userRound: {
        type: Number,
        required: false,
        default: 1,
      },
      currentPageUser: {
        type: Number,
        required: false,
        default: 1,
      },
      roundResultsPages: {
        type: Number,
        required: false,
        default: 1,
      },
    },
    data() {
      return {
        selectedRound: this.userRound,
        selectedPage: this.currentPageUser,
        selectedRoundResultsPages: this.roundResultsPages,
        results: this.roundResults,
      }
    },
    computed: {
      competitionId(): number {
        return this.competition ? parseInt(this.competition.id) : null;
      },
      competitionStatusId(): number {
        return this.competition.status_id ? this.competition.status_id : 0;
      },
      numRounds(): number {
        return this.dateRounds ? this.dateRounds.length : 1;
      },
      isCompetitionPending(): boolean {
        return this.competitionStatusId === COMPETITION_STATUS_ID.PENDING;
      },
      isCompetitionConfirmed(): boolean {
        return this.competitionStatusId === COMPETITION_STATUS_ID.CONFIRMED;
      },
      roundChangeDisabled(): boolean {
        return this.isCompetitionPending || this.isCompetitionConfirmed;
      },
    },
    methods: {
      onRoundClick(round: number): void {
        if (!this.roundChangeDisabled) {
          this.selectedRound = round;
          this.selectedPage = 1;
          this.reloadCompetitionRoundResults();
        }
      },
      onPreviousRoundClick(): void {
        if (!this.roundChangeDisabled) {
          const round = this.getPreviousRound(this.selectedRound);
          this.onRoundClick(round);
        }
      },
      onNextRoundClick(): void {
        if (!this.roundChangeDisabled) {
          const round = this.getNextRound(this.selectedRound);
          this.onRoundClick(round);
        }
      },
      onPreviousPageClick(): void {
        this.selectedPage = this.getPreviousPage();
        this.reloadCompetitionRoundResults();
      },
      onNextPageClick(): void {
        this.selectedPage = this.getNextPage();
        this.reloadCompetitionRoundResults();
      },
      getPreviousRound(selectedRound: number): number {
        return (selectedRound > 1)
          ? selectedRound - 1
          : this.numRounds;
      },
      getNextRound(selectedRound: number): number {
        return (selectedRound >= this.numRounds)
          ? 1
          : selectedRound + 1;
      },
      getPreviousPage(): number {
        return (this.selectedPage > 1)
          ? this.selectedPage - 1
          : this.selectedRoundResultsPages;
      },
      getNextPage(): number {
        return (this.selectedPage >= this.selectedRoundResultsPages)
          ? 1
          : this.selectedPage + 1;
      },
      getRoundStartDate(round: number): string {
        const roundData: any = this.dateRounds[round - 1];

        return roundData.datetime;
      },
      async reloadCompetitionRoundResults() {
        this.showLoader(true);

        const params = {
          page: this.selectedPage,
        };

        try {
          const {data}: any = await this.$http.page.getCompetitionsRoundResultsPage(
            this.competitionId,
            this.userId,
            this.selectedRound,
            params
          );
          this.results = data.data.results;
          // eslint-disable-next-line radix
          this.selectedRoundResultsPages = parseInt(data.data.pages);
          this.showLoader(false);
        } catch (e) {
          this.results = [];
          this.selectedRoundResultsPages = 1;
          this.showLoader(false);
        }
      }
    },
    watch: {
      competitionId() {
        this.selectedRound = this.userRound;
        this.selectedPage = this.currentPageUser;
        this.selectedRoundResultsPages = this.roundResultsPages;
        this.results = this.roundResults;
      },
    }
  });
